import { produce } from "immer";
import * as Actions from "pages/Statistics/store/statisticsActions";

const initialState = {
  errorMessage: null,
  isLoading: false,
  details: null,
  searchParams: { startDate: "", endDate: "" }
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_STATISTICS:
      draft.isLoading = true;
      draft.errorMessage = null;
      break;

    case Actions.FETCH_STATISTICS_SUCCESS:
      const payload = action.payload;
      const statistics = payload.statistics;

      draft.isLoading = false;
      draft.details = statistics;
      break;

    case Actions.FETCH_STATISTICS_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.SET_SEARCH_PARAMS:
      draft.searchParams = action.payload;
      break;

    default:
      break;
  }
}, initialState);

export default reducer;
